import React from 'react';
import NumberFormat from 'react-number-format';

const InputNumberFormat = React.forwardRef(({ onChange, ...props }, ref) => (
  <NumberFormat
    {...props}
    getInputRef={ref}
    allowNegative={false}
    onValueChange={({ value, floatValue }) => {
      onChange({ target: { value: floatValue } });
    }}
  />
));

export default InputNumberFormat;
